export default {
    weatherUrl: "http://localhost:8080/weather"
}